import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role'
import { Card, CardContent } from '@mui/material';


import { useFetchInitCalendar } from './hooks';
import { EventClassification } from './Calendar/EventClassification';
import { Calendar } from './Calendar/Calendar'

const Agenda = () => {
    const location = useLocation();
    const paramsURL = useParams();

     const useFetchInit = useFetchInitCalendar({location, paramsURL})

    return (
        <AllowedAccess permissions={['92_CALENDARIO']} renderAuthFailed={<p>Error</p>}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <Calendar useFetchInit={useFetchInit} />
                        {/* <EventClassification/> */}
                    </CardContent>
                </Card>
        </AllowedAccess>
    )
}

export {
    Agenda
}


